import React from 'react';
import { DollarSign } from 'lucide-react';
export function TestimonialsSection() {
  const testimonials = [{
    name: 'Diego',
    amount: '$1.500 USD/mes',
    text: 'Entró en una empresa de Estados Unidos gracias a la bolsa de trabajo del curso, donde gana 1500 dólares recurrentes todos los meses, dándole libertad y mejor calidad de vida.',
    image: 'https://cdn.magicpatterns.com/uploads/vuyfviigPJkiHDwBJ2hB4C/Diego.jpg'
  }, {
    name: 'Tiziano',
    amount: '$2.000 USD/mes',
    text: 'Logró generar 2000 dólares al mes editando y dirigiendo equipos de Estados Unidos.',
    image: 'https://cdn.magicpatterns.com/uploads/g3fcbwv68v5TAWk5pqnnwh/Tiziano.jpg'
  }, {
    name: 'Franco',
    amount: '$3.000 USD/mes',
    text: 'Logró escalar a 3000 dólares al mes especializándose en contenido para grandes empresarios.',
    image: 'https://cdn.magicpatterns.com/uploads/2wJAZRKDETXWX5JPV3hEu5/Franco.jpg'
  }];
  return <section className="py-16 md:py-24 bg-slate-900 px-4" data-id="element-151">
      <div className="max-w-6xl mx-auto" data-id="element-152">
        <h2 className="text-3xl md:text-4xl font-bold text-center text-white mb-4" data-id="element-153">
          ¿Querés tener resultados como{' '}
          <span className="text-blue-400" data-id="element-154">Franco, Diego y Tiziano</span>?
        </h2>
        <p className="text-slate-400 text-center text-lg mb-14 max-w-2xl mx-auto" data-id="element-155">
          Ellos empezaron desde cero y hoy generan ingresos reales editando
          videos. Acá están sus historias.
        </p>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-156">
          {testimonials.map((testimonial, index) => <div key={index} className="bg-slate-800 rounded-2xl border border-slate-700 overflow-hidden flex flex-col" data-id="element-157">
              {/* Photo */}
              <div className="relative w-full aspect-square bg-slate-700 overflow-hidden" data-id="element-158">
                <img src={testimonial.image} alt={testimonial.name} className="w-full h-full object-cover" data-id="element-159" />
                <div className="absolute inset-0 bg-gradient-to-t from-slate-900 via-transparent to-transparent" data-id="element-160" />
                <div className="absolute bottom-4 left-4 right-4" data-id="element-161">
                  <h3 className="text-2xl font-bold text-white" data-id="element-162">
                    {testimonial.name}
                  </h3>
                </div>
              </div>

              {/* Content */}
              <div className="p-6 flex flex-col flex-grow" data-id="element-163">
                <div className="flex items-center gap-2 mb-4" data-id="element-164">
                  <div className="w-10 h-10 bg-blue-600/20 rounded-full flex items-center justify-center" data-id="element-165">
                    <DollarSign className="w-5 h-5 text-blue-400" data-id="element-166" />
                  </div>
                  <span className="text-blue-400 text-xl font-extrabold" data-id="element-167">
                    {testimonial.amount}
                  </span>
                </div>

                <p className="text-slate-300 leading-relaxed flex-grow" data-id="element-168">
                  {testimonial.text}
                </p>

                <div className="flex text-yellow-400 text-sm mt-4" data-id="element-169">
                  {'★★★★★'}
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}